import { makeAutoObservable } from 'mobx';

/**
 * @typedef {EN.Tournament} default
 */

export class Tournament {
  /**
   * @param {EN.Tournament} model
   */
  constructor(model) {
    makeAutoObservable(this);

    /** @type {EN.Tournament['id']} */
    this.id = '';
    /** @type {EN.Tournament['lid']} */
    this.lid = '';
    /** @type {EN.Tournament['pid']} */
    this.pid = '';
    /** @type {EN.Tournament['slug']} */
    this.slug = '';
    /** @type {EN.Tournament['disciplineId']} */
    this.disciplineId = '';
    /** @type {EN.Tournament['isUnsubscribed']} */
    this.isUnsubscribed = false;

    Object.assign(this, model);
  }

  eventIds = [];

  eventRefs = [];

  name = '';

  sortIndex = 0;

  update(data) {
    Object.assign(this, data);
  }
}
